import styled from "styled-components";
import { device } from "common/src/styles/Reset";

export const LoadingGif = styled.p`
  height: 100px;
  width: 100px;
  position: relative;
  background-color: #fff;
  border-radius: 8px 8px 8px 0;
  img {
    width: 45px;
    height: 45px;
    position: absolute;
    bottom: 0;
    right: 0;
    left: 0;
    top: 0;
    margin: auto;
  }
`;
